import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container, Col, Row } from 'react-bootstrap'
import { Paper, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import { IoAddCircleOutline, IoFilter } from "react-icons/io5"
import { useOutletContext } from 'react-router-dom'
import { Form } from 'antd'

import DataTable from 'Shared/Components/DataTable'
import { FormContainer, Dropdown } from 'Shared/Components/FormComponents'
import PopupModal from 'Shared/Components/PopupModal'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const PermitToWorkList = () => {
  const { role, projectInfo, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const tableRef = useRef()

  const filterRef = useRef({
    "template": []
  })

  const [form] = Form.useForm()
  
  const [formTemplates, setFormTemplates] = useState([])
  const [forms, setForms] = useState([])

  const [createModalOpen, setCreatecreateModalOpen] = useState(false)
  const [filterFormOpen, setFilterFormOpen] = useState(false)

  const getFormTemplates = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/permit_to_work/templates`,
      returnType: "json"
    })

    setFormTemplates(body)
  }

  const getForms = async () => {
    const getStatus = (i) => {
      switch (i["status"]) {
        case -100:
          return "Missing"
        case -101:
          return "Expired"
        case 0:
          return "Pending"
        case 100:
          return "Issued"
        case 101:
          return "Cancelled"
        case 102:
          return "Voided"
        default:
          return null
      }
    }

    const body = await send({
      method: "GET",
      url: `${apiUrl}/permit_to_work/forms`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"],
        "template": filterRef.current.template.join("|"),
      },
      returnType: "json"
    })

    setForms({
      "data": body["data"].map((i) => ({
        "id": i["form_id"],
        "template_id": i["template_id"],
        "template_name": i["template_name"],
        "worker_name": i["worker_name"],
        "company": i["company"],
        "start_time": i["permit_start_time"],
        "end_time": i["permit_end_time"],
        "status": i["status_ext"] ? <div>{i["status_ext"]}</div> : <div className={i["status"] >= 0 ? 'text-normal' : 'text-alert'}>{getStatus(i)}</div>
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async() => {
      setPageLoading(true)

      await Promise.all([
        getFormTemplates(),
        getForms()
      ])

      setPageLoading(false)
    }
    
    init()
  }, [])

  const loadData = async () => {
    tableRef.current.setTableLoading(true)

    await getForms(false)

    tableRef.current.setTableLoading(false)
  }

  const onClick = (e, row) => {
    navigate(`./${row["template_id"]}/${row["id"]}`)
  }

  const onFinish = (value) => {
    filterRef.current.template = value["template"] ?? []

    setFilterFormOpen(false)
    tableRef.current.setPage(1)

    loadData()
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={forms["data"]} count={forms["count"]} ref={tableRef}
              onRowClick={(projectInfo["info"]["ptw"]["supplier"] === "" || projectInfo["info"]["ptw"]["supplier"] === "novade") ? function(e, row) { onClick(e, row) } : null} loadData={loadData}
              columns={{
                "template_name": { "label": (projectInfo["info"]["ptw"]["supplier"] !== "") ? t("ptw_formName") : t("ptw_templateName"), "sorting": false, "nowrap": false },
                "worker_name": { "label": t("ptw_workers"), "sorting": false, "nowrap": false, "hidden": (projectInfo["info"]["ptw"]["supplier"] !== "") },
                "company": { "label": t("ptw_company"), "sorting": false, "nowrap": false },
                "start_time": { "label": t("ptw_startTime"), "sorting": false, "nowrap": true },
                "end_time": { "label": t("ptw_endTime"), "sorting": false, "nowrap": true },
                "status": { "label": t("ptw_status"), "sorting": false, "nowrap": true },
              }}
              appActions={() => { return [
                ((projectInfo["info"]["ptw"]["supplier"] === "") && ["admin", "pm"].includes(role)) && {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { setCreatecreateModalOpen(true) }},
                {icon: <IoFilter size={20}/>, text: t("general_filter"), onClick: function() { form.setFieldsValue({ "items": filterRef.current.search, "date": filterRef.current.date }); setFilterFormOpen(true); }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={filterFormOpen} close toggle={() => setFilterFormOpen(false)} height="80%" width="80%">
      <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
        <Dropdown field_name={t("ptw_templateName")} field_id="template" props={{"multiple": true, "options": formTemplates.map((i) => ({"label": i["template_name"], "value": i["template_id"]}))}} />
      </FormContainer>
    </PopupModal>

    <PopupModal isOpen={createModalOpen} maxHeight="50%" width="70%" close toggle={() => setCreatecreateModalOpen(false)}>
      <List style={{ padding: "0px" }}>
        {(formTemplates).map((i) => 
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary={i["template_name"]} secondary={i["description"]} onClick={() => navigate(`./${i["template_id"]}`)} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </PopupModal>
  </>)
}

export default PermitToWorkList